import { RefundMoneyRequestStatus } from '@/types/refundMoneyRequest'

export const StatusLabels = {
  [RefundMoneyRequestStatus.Succeeded]: { label: 'Возращен', color: 'green' },
  [RefundMoneyRequestStatus.Canceled]: { label: 'Отклонен', color: 'red' },
  [RefundMoneyRequestStatus.Created]: { label: 'Создан', color: 'secondary' },
}